/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Round_CapInputs */



/**
* | output |
* | --- |
* | "Max rounds per player" |
*
* @param {Tfield_Round_CapInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_round_cap = /** @type {((inputs?: Tfield_Round_CapInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Round_CapInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes max par joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas máx. por jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Máx. de rodadas por jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round max per giocatore")
	return /** @type {LocalizedString} */ ("Max rounds per player")
});